import { shallowEqual as reduxShallowEqual } from "react-redux";

/**
 * The type of `shallowEqual` in DefinitelyTyped is bad, and makes `useSelector` return `any` without
 * manual generics.
 */
export const shallowEqual = <T>(left: T, right: T): boolean => reduxShallowEqual(left, right);
